import { FormControl } from "@angular/forms";
import { BotIA } from "../bot-ia/bot-ia.interface";
import { brandSourcesResponse, brandsResponse, BussinessTypesResponse, DistributorsByBrandMTYResponse, DistributorsPhonesResponse, NoResponseRule, SegmentationItem, subcampainsResponse, TimePeriod } from "../catalogs/catalogs.interface";

export interface AIConfigurationData {
  catalogs: {
    subcampains?: subcampainsResponse[];
    brands?: brandsResponse[];
    distributors?: DistributorsByBrandMTYResponse[];
    bussinessTypes?: BussinessTypesResponse;
    timePeriods?: TimePeriod[];
    distributorsPhones?: DistributorsPhonesResponse[];
    botIaList?: BotIA[];
    allBrandsSources?: brandSourcesResponse[];
    allSubcampains?: subcampainsResponse[]
    segmentation?: SegmentationItem[];
    baseBrands?: brandsResponse[];
    noResponse?: NoResponseRule[];
    subbrandsMultibrand?: SegmentationItem[];
    attentionTouch?: boolean;
  },
  botSettingsInfo: botSettings,
  loadedBotInfo: boolean,
  editingBot: boolean
}
export interface  botSettingsResponse{
  success: boolean;
  message: string;
  response: botSettings;
}

export interface botSettings{
  iarequest: iarequest;
  horarios: iaHorario[];
  iaPlantilla?: iaPlantilla;
  promtingBienvenida: string,
  promtingDespedida: string,
  promtingRecontacto?: string,
  promtingRecontactoDos?: string,
  promtingRecontactoTres?: string,
  credencialVoz?: CredencialVoz,
  iaVoz?: IaVoz,
  idPromptingBienvenidaPlayground?: string,
  submarcas?: SubbrandRelated[],
  promtingBienvenidaDos?: string,
  promtingBienvenidaTres?: string
}

export interface iarequest{
  idia?: string,
  titulo: string,
  tipo: number | null,
  idaccionnorespuesta: number | null,
  idplantillabienvenida: number | null,
  idtipodenegocio: string,
  idmarca: string,
  iddistribuidor: string,
  idfuente: string,
  idcampana: string,
  habilitarwhatsapp: boolean,
  nocontacto: number,
  habilitartelefonia: boolean,
  agentes: number,
  restingirhorarios: boolean,
  idproveedor: string,
  idcreado: string,
  nombreCreado: string,
  creado: string,
  activo: boolean,
  nocontactoperiodo: number | null,
  intentoDeRecontacto?: boolean | null,
  numeroDeReintentos?: number | null,
  telefono: string,
  idPlantillaPlayground: string,
  idsegmento: string,
  segmento: string,
  prioridad: boolean,
  idSubmarca: string,
  submarca: string,
  citaDomicilio: boolean,
  maximoKm: number,
  anioMinimo?: number,
  autorizado: boolean,
  atencion: number,
  telefonoPg: string,
  flujoPool: boolean,
  idPool: string,
  tipoMarca: number,
  marca: string,
  despuesDeChatbot: number,
  idPeriodoChatbot: number,
  idChatbot: string,
  idBdc: string,
  idDistribuidorBdc?: string,
  canales: string,
  iddistribuidorlinea?: string,
  conCita?: boolean | null,
  idBdcConCita?: string | null,
  idPoolConCita?: string | null,
  sinCita?: boolean | null,
  idBdcSinCita?: string | null,
  idPoolSinCita?: string | null,
  tiempoEsperaReintento?: number | null,
  idPeriodoEsperaReintento?: number | null,
  caidaProspectoRecontacto?: boolean | null,
  idBdcRecontacto?: string | null,
  idPoolRecontacto?: string | null,
}

export interface iaPrompting{
  id: {
      idia?: string
      idcategoria: string
  },
  prompting: string,
  certificado: boolean,
  idCreado: string,
  creado: string,
  idReferencia: string,
  activo: boolean,
}
export interface iaPlantilla{
  idPlantilla: number
}
export interface iaHorario{
  idhorario: string,
  inicio: `${number}:${number}:${number}`,
  fin: `${number}:${number}:${number}`,
  lunes: boolean,
  martes: boolean,
  miercoles: boolean,
  jueves: boolean,
  viernes: boolean,
  sabado: boolean,
  domingo: boolean,
  idCreado: string,
  creado: string,
}

export interface duplicateBotResponse{
  success: boolean;
  message: string;
  ia: BotIA;
}

export enum botWelcomeTemplates {
  "Bienvenido al bot de Atención automotriz",
  "Bienvenido al bot de Marketing automotriz",
  '¡Hola, [prospectos.nombre]! Soy tu Asesor de [prospectos.distribuidor] y me alegra que estes interesado en estrenar uno de nuestros autos! Estoy aquí para resolver todas tus dudas, listo para comenzar?',
  "Bienvenido al bot de Proceso automotriz"
}

export interface CredencialVoz {
  idCredencialVoz: string;
  idIa:            string;
  token:           string;
  numero:          string;
  activo:          boolean;
}
export interface IaVoz {
  idIa:            string;
  voz:             string;
  idTono:          string;
  nombreTono:      string;
  idAcento:        string;
  nombreAcento:    string;
}
export type NoResponseForm = {
  intentoDeRecontacto?: FormControl<boolean | null>;
  numeroDeReintentos?: FormControl<number | null>;
  nocontacto: FormControl<string | null>;
  nocontactoperiodo: FormControl<string | null>;
  idaccionnorespuesta: FormControl<string | null>;
  prioridad: FormControl<boolean | null>;
  despuesDeChatbot?: FormControl<string | null>;
  idPeriodoChatbot?: FormControl<string | null>;
  idChatbot?: FormControl<string | null>;
  idPool: FormControl<number | null>;
  idBdc?: FormControl<string | null>;
  asignarPrincipal?: FormControl<boolean | null>;
  conCita?: FormControl<boolean | null>;
  idBdcConCita?: FormControl<string | null>;
  idPoolConCita?: FormControl<string | null>;
  sinCita?: FormControl<boolean | null>;
  idBdcSinCita?: FormControl<string | null>;
  idPoolSinCita?: FormControl<string | null>;
  tiempoEsperaReintento?: FormControl<number | null>;
  idPeriodoEsperaReintento?: FormControl<number | null>;
  caidaProspectoRecontacto?: FormControl<boolean | null>;
  idBdcRecontacto?: FormControl<string | null>;
  idPoolRecontacto?: FormControl<string | null>;
};

export interface SubbrandRelated {
  idSubmarca?: string,
  submarca?: string
}
